import { Skeleton } from "@mui/material";
import { Table } from "../../../../components";
import { dataTable } from "./handlers";

const SkeletonTableDataGrid = () => {
  const dataTableSkeleton = {
    data: [
      {
        id: 1,
        nombre: "",
        img_url: "",
        estado: 1,
      },
      {
        id: 2,
        nombre: "",
        img_url: "",
        estado: 1,
      },
      {
        id: 3,
        nombre: "",
        img_url: "",
        estado: 0,
      },
      {
        id: 4,
        nombre: "",
        img_url: "",
        estado: 1,
      },
      {
        id: 5,
        nombre: "",
        img_url: "",
        estado: 1,
      },
      {
        id: 6,
        nombre: "",
        img_url: "",
        estado: 1,
      },
      {
        id: 7,
        nombre: "",
        img_url: "",
        estado: 0,
      },
      {
        id: 8,
        nombre: "",
        img_url: "",
        estado: 1,
      },
    ],
    error: null,
    params: null,
    loading: false,
  };

  return (
    <Table
      loading={true}
      search={true}
      data={dataTable(dataTableSkeleton?.data)}
      render={() => {
        return (
          <div className="d-flex justify-content-center align-items-center ">
            <Skeleton variant="rectangular" className="rounded m-2" height={38} width={99} />
            <Skeleton variant="rectangular" className="rounded m-2" height={38} width={117} />
          </div>
        );
      }}
    />
  );
};
export default SkeletonTableDataGrid;
